import LandLoadPropertyCard from './LandLoadPropertyCard';
import LandLordTestSummary from '../../pages/LandLord/LandLordTestSummary';
import { Pagination } from 'antd';
import { useState, useEffect } from 'react';

const LandlordDashboard = ({ 
  properties, 
  showTable, 
  selectedProperty, 
  onViewUnits, 
  onBackToCards,  
  onEditProperty, 
  onDeletePropertyCard,
  totalRecords,
  fetchProperties,
  search
}) => {

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(6);


  const onPageChange = (page) => {
    
    setCurrentPage(page);
    fetchProperties(page, pageSize, search);
  };

  const filteredProperties = properties.filter(property => 
    property.propertyName.toLowerCase().includes(search.toLowerCase()) // Filter by property name
  );

  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = currentPage * pageSize;
  const paginatedProperties = filteredProperties.slice(startIndex, endIndex);

  return (
    <>
      {showTable ? (
        <div>
          <LandLordTestSummary property={selectedProperty} />
        </div>
      ) : (
        <div className="flex flex-wrap justify-center [@media(min-width:860px)]:justify-start mr-6 gap-x-[76px] gap-y-4">
          {paginatedProperties?.map((property, index) => (
            <div
              key={index}
              className="
                sm:w-[336px] 
                md:w-[342px] 
                lg:w-[278px]
                max-w-[90vw]
              "
            >
              <LandLoadPropertyCard
                title={property?.propertyName}
                location={property?.location[0].city}
                occupied={property?.occupied}
                vacant={property?.vacant}
                totalUnits={property?.totalUnits}
                expectedRent={property?.rentExpected}
                rentCollected={property?.totalRentCollected}
                rentCollectedThisMonth={property?.currentMonthOnTimeAmount}
                onViewUnits={() => onViewUnits(property)}
                onEdit={() => onEditProperty(property)}
                onDelete={() => onDeletePropertyCard(property)}
              />
            </div>
          ))}
        </div>
      )}

      <div className="flex justify-center pb-5">
        <Pagination
          current={currentPage}
          total={filteredProperties.length}
          pageSize={pageSize}
          onChange={onPageChange}
          showSizeChanger={false}
          className="custom-pagination"
          hideOnSinglePage={true}
          showLessItems
        />
      </div>

    </>
  );
};

export default LandlordDashboard;
